<ng-template #subLayerRef let-node="node">
  <div>
    @if (nodeVisible(node)) {
      <rask-checkbox class="low" [(ngModel)]="node.checked"
        [disabled]="node.disabled || node.readonly || node.error"
        [attr.disabled]="(node.disabled || node.readonly || node.error) ? true : null" [text]="node.name"
        [partialChecked]="node.partiallyChecked">
      </rask-checkbox>
    }
  </div>

  @if (!!nodes) {
    <ul class="sub-layer">
      @for (node of node.nodes; track node.name) {
        <li>
          <!-- Recursive template -->
          <ng-template
            [ngTemplateOutlet]="subLayerRef"
            [ngTemplateOutletContext]="{ node: node }">
          </ng-template>
        </li>
      }
    </ul>
  }
</ng-template>

@if (!!nodes) {
  <div class="layer-list">
    @if (nodes.length === 0) {
      <div>
        <span>{{texts.nolayers}}</span>
      </div>
    }
    @for (node of nodes; track node.name) {
      <rask-toggle-panel size="4" [label]="node.name" [disabled]="node.type === 'draw'">
        <ng-container header>
          <rask-checkbox class="low" [(ngModel)]="node.checked"
            [disabled]="node.disabled || node.readonly || node.error" [attr.disabled]="node.disabled || node.error ? true : null"
            [partialChecked]="node.partiallyChecked">
          </rask-checkbox>
        </ng-container>
        <ng-container>
          <rask-tabs [size]="4" aid="layerList" layout="child">
            <rask-tab [label]="texts.layers">
              @for (n of node.nodes; track n.name) {
                <ul class="layer">
                  <div>
                    <ng-template
                      [ngTemplateOutlet]="subLayerRef"
                      [ngTemplateOutletContext]="{ node: n }">
                    </ng-template>
                  </div>
                </ul>
              }
            </rask-tab>
            <rask-tab [label]="texts.legendInfo">
              <div class="legend-container">
                <rask-layer-legend [root]="node"></rask-layer-legend>
              </div>
            </rask-tab>
            <rask-tab label="Opacitet">
              <rask-slider class="col-12" [(ngModel)]="node.opacity" [min]="0" [max]="1" [step]="0.01"
                [viewFormatter]="sliderOpacityValueFormatter"
                [useLabels]="true">
              </rask-slider>
            </rask-tab>
          </rask-tabs>
        </ng-container>
      </rask-toggle-panel>
    }
  </div>
}
